import { useTranslation } from 'react-i18next';
import { Sparkles } from 'lucide-react';
import { cn } from '@/lib/utils';

interface WelcomeHeaderProps {
  userName: string;
  className?: string;
}

export function WelcomeHeader({ userName, className }: WelcomeHeaderProps) {
  const { t } = useTranslation('tips');

  const firstName = userName.split(' ')[0] || userName;

  return (
    <div className={cn('text-center', className)}>
      <div className="w-14 h-14 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
        <Sparkles className="h-7 w-7 text-blue-600" />
      </div>
      <h1 className="text-2xl font-semibold text-gray-900 mb-2">
        {t('welcome.title', { name: firstName })}
      </h1>
      <p className="text-gray-600">
        {t('welcome.subtitle')}
      </p>
    </div>
  );
}
